module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[28]393.4f50022.woff2";